import { Product } from "../Classes/Product";
import { Product365 } from "../Classes/Product365";
import {initFormStep} from "./initSteps";
import {initAddOnStep} from "./initAddOns";
import { loadNextStepModule } from "../modules/loadNextStepModule";
import { initPlaces } from "./initPlaces";
import { directlyHideStep, fadeInStepAnimation, fadeOutStep } from "./stepAnimations";
import { getParameterByName } from "../misc/misc-functions";
import { loadRequestForm } from "../requestForm/requestform";

export function getProductImportance(productName) {
    let m365packages = {
        exchange: 0,
        basic: 1,
        standard: 2,
        premium: 3,
        individual: 4,
    }
    let importance = m365packages.hasOwnProperty(productName) ? m365packages[productName] : -1;

    return importance;
}




function initFormStepsAndFunctions(product365, product, cart) {
    initFormStep(product365, product, cart)
    initAddOnStep(product365, product, cart)
    initPlaces(product365, product, cart)
    loadRequestForm(cart);
}



export function loadProductConfigurator(cart) {

    
    
    let product365 = new Product365();
    let product = new Product();
    
    initFormStepsAndFunctions(product365, product, cart)
    tippy('[data-tippy-content]');
    

    let formStart = getParameterByName('start');
    console.log(formStart)
    if(formStart) {
        let formStep = document.getElementById('form-question-1');

        if(formStart === 'anfrage' || formStart === 'product') {

            directlyHideStep(formStep.parentElement);
        }

        if(formStart === 'anfrage') {
            product365.updateNameAndImportance('individual', getProductImportance('individual'));
            product.updateProduct(product365);
            loadNextStepModule.getNextStep(2, product365.get().name)

        } else if(formStart === 'product') {
            product365.updateNameAndImportance('exchange', getProductImportance('exchange'));
            product.addFormAnswer('Ich möchte weniger als 300 Plätze ausstatten')
            product.updateProduct(product365);
            loadNextStepModule.getNextStep(2, product365.get().name)
        }

    }


    const elements = {
        allStepsHolder: document.getElementById("form-holder"),
    }

    loadNextStepModule.on("load", () => {
        elements.allStepsHolder.classList.add("open");
    })

    loadNextStepModule.on("create", (data) => {
        let stepHolders = document.querySelectorAll(".step-holder");
        for (let stepHolder of stepHolders) { stepHolder.classList.remove("active") }

        let nextStepHolder = document.createElement("div");
        nextStepHolder.classList.add("step-holder", "active")
        nextStepHolder.innerHTML = data
        elements.allStepsHolder.appendChild(nextStepHolder)

        fadeInStepAnimation(nextStepHolder).restart();

    })
    loadNextStepModule.on("loadComplete", () => {
        loadNextStepModule.showContent();

    })

    loadNextStepModule.on("show", () => {
        elements.allStepsHolder.classList.remove("blurred", "loading-text")

        initFormStepsAndFunctions(product365, product, cart)
        tippy('[data-tippy-content]');
        console.log(product)
    })


    loadNextStepModule.on("error", (message) => {
        console.error(message)
    })

    loadNextStepModule.on("urlError", (message) => {

    })

}